/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:37:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 15:52:53                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * AdminInterventionsTab: Admin interventions tab
*/

/* Imports */
import { useCallback, useEffect, useState } from "react";
/***/

/* Services */
import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import { createListQuery, searchWithFilters } from "../../../../../../services/api/search";
import { api } from "../../../../../../services/api/api";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import WorkorderOriginForm from "../../../../../../components/data/workorder-origin/WorkorderOriginForm";
import WorkorderOriginListItem from "../../../../../../components/data/workorder-origin/WorkorderOriginListItem";
/***/

/**
* AdminInterventionsTab: Admin interventions tab
*/
export default function AdminInterventionsOriginsTab() {
  const [origins, setOrigins] = useState<EasyTech.WorkorderOrigin[] | null>(null);

  const TABLE_HEAD = [
    {
      label: "Label",
      orderKey: "label"
    },{
      label: "Active",
      orderKey: "enabled"
    }, {
      label: "actions",
      orderKey: null
    }
  ];
  

  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const createOrigin = (type: EasyTech.WorkorderOrigin): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (type.translations) {
        type.translations = type.translations.filter((el: EasyTech.Translation) => {
          const cond = !el.label;
          return !cond;
        });
      }
      if (type && type.label) {
        api.post("users/workorder_origins", type).then((ret) => {
          loadWorkordersOrigins();
          toast.success("Intervention origin created");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la création de l'origine d'intervention" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  const loadWorkordersOrigins = useCallback(() => {
    searchWithFilters<EasyTech.WorkorderOrigin>("workorder_origins", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, false)
      .then(ret => setOrigins(ret.data as EasyTech.WorkorderOrigin[]))
      .catch(err => {
        console.error(err);
        setOrigins([]);
      });
  }, []);
  
  /**
  * useEffect: get interventions list 
  * on init
  */
  useEffect(() => {
    loadWorkordersOrigins();
  }, [loadWorkordersOrigins]);
  /***/
  

  return (
    <div>
      <div className="icon-buttons flex gap-2">
        <EditCreateDrawer data={({} as EasyTech.WorkorderOrigin)}
                                  entityName="Intervention origin"
                                  FormComponent={WorkorderOriginForm}
                                  isNotEditable={true}
                                  onSubmit={createOrigin}
                                  createButtonText="Create new Intervention Origin" />
      </div>

      <div className="my-6">
        {origins ?
          <Table  tableHead={TABLE_HEAD}
                  emptyTable={(!origins || origins.length === 0) ? "No types" : false}>
            {origins.map((lang, index) => (
              <WorkorderOriginListItem  key={lang.id+"-"+index} origin={lang} isLast={index === origins.length - 1} onChange={loadWorkordersOrigins} />
            ))}
          </Table>
        : <Loading/>}
      </div>
      
    </div>
  );
}
/***/
